function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.68 2.161c.238-1.55-1.76-2.38-2.69-1.118L5.781 17.61C5.052 18.6 5.759 20 6.99 20h5.844l-1.513 9.839c-.239 1.55 1.76 2.38 2.69 1.118L26.218 14.39c.73-.99.023-2.39-1.207-2.39h-5.845l1.513-9.839z"
});

var SvgNowBoltFill = function SvgNowBoltFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "34b668db21dc3251dbe1fd48eb402c34.svg";
export { SvgNowBoltFill as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/now-bolt-fill.svg
// module id = null
// module chunks = 